import React from "react";
import TabellaKpiController from "./TabellaKpiController";

export default function DatiGeneraliKpi({
                                            strutturaKpi,
                                            formikRef,
                                            aggiornaValoriTabellaKpi,
                                        }) {

    return (
        <div className={"row mt-4"}>
            <div className={"col-md-12"}>
                <TabellaKpiController
                    tabella={strutturaKpi}
                    modifica={false}
                    formikRef={formikRef}
                    handlerChange={aggiornaValoriTabellaKpi}
                />
            </div>
        </div>
    );
}